import gbTranslations from "@/languages/gb.js";
import mkTranslations from "@/languages/mk.js";
import bgTranslations from "@/languages/bg.js";

const translations = {
  gb: gbTranslations,
  mk: mkTranslations,
  bg: bgTranslations
};

export default translations;
